<template>
  <div class="wallet-container">
    <v-container fluid class="pa-0">
      <!-- Balance Card -->
        <ModalDeposit
          v-if="(create_access || update_access)"
          modal_title="Ingresar dinero"
          :dialog="dialog_wallet"
          :service="service"
          @updateDialog="updateDialogWallet"
          @depositCreated="onDepositCreated"
          :statusTitle="depositStatusTitle"
          :statusMessage="depositStatusMessage"
          :paymentStatus="depositPaymentStatus"
          :step_pay="depositStep"
        />
      <div class="balance-card">
        <v-row>
          <v-col cols="8">
            <div class="balance-header">
              <h3 class="balance-title mb-0">Dinero disponible</h3>
              <div class="balance-amount" v-if="!loadingBalance">${{ formatBalance }}</div>
              <div class="balance-amount-loading" v-else>
                <v-skeleton-loader type="text" width="200px"></v-skeleton-loader>
              </div>
            </div>
          </v-col>
          <v-col cols="4" class="d-flex justify-end align-center">
            <Button flat :loading="false" text @click="handleAddMoney" :disabled="!(create_access || update_access)"
              class="bg-button-deposit btn text-capitalize text-white btn-modal w-100" rounded="xl" height="45"
              label="Ingresar Dinero" ></Button>
          </v-col>
        </v-row>
       
      </div>

      <Filters  @loadList="loadList" :service="service" @loadBalance="loadBalance"/>

      <!-- Movements List Card -->
      <div class="movements-card">
        <div v-if="loading" class="loading-container">
          <v-skeleton-loader 
            v-for="n in 5" 
            :key="n"
            type="text"
            class="mb-3"
          />
        </div>
        
        <div v-else-if="list.length === 0" class="empty-state">
          <div class="empty-text">No hay movimientos para mostrar</div>
        </div>

        <div v-else class="movements-list">
          <div 
            v-for="movement in list" 
            :key="movement.id" 
            class="movement-item"
          >
            <div class="movement-icon">
              <v-icon 
                :color="getMovementColor(movement)" 
                size="24"
              >
                {{ getMovementIcon(movement) }}
              </v-icon>
            </div>
            
            <div class="movement-content">
              <div class="movement-title">{{ getMovementTitle(movement) }}</div>
              <div class="movement-description">{{ getMovementDescription(movement) }}</div>
            </div>
            
            <div class="movement-amount">
              <div 
                class="amount-text" 
                :class="getMovementColor(movement)"
              >
                {{ getMovementAmountText(movement) }}
              </div>
              <div class="movement-description">{{ formatUtils.formatDateShort(movement.date_created) }}</div>
            </div>
          </div>
        </div>
      </div>

         <v-pagination v-if="cant_pages > 1" v-model="current_page" :length="cant_pages" @next="loadPage(service)"
          @prev="loadPage(service)" @first="loadPage(service)" @update:modelValue="loadPage(service)"></v-pagination>
    </v-container>
  </div>
</template>

<script>
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { walletService } from "@/libs/ws/Seller/walletService";
import { formatUtils } from "@/libs/utils/formatUtils";
import Button from "@/components/Button.vue";
// import Pagination from "@/components/Pagination.vue";
import Filters from "./Filters.vue";
import ModalDeposit from "./ModalDeposit.vue";

export default {
  name: "Billetera",
  components: { 
    Button,
    ModalDeposit,
    // Pagination,
    Filters
  },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: walletService,
      formatUtils: formatUtils,
      loading: true,
      mainFilters: {
        from_date: null,
        to_date: null,
        seller_id: null
      },
      current_balance: this.$store.state.user.balance,
      loadingBalance: false,
      depositStatusTitle: "",
      depositStatusMessage: "",
      depositPaymentStatus: "pending",
      depositStep: 1,
      dialog_wallet: false,
      seller_info: this.$store.state.user.seller_info
    };
  },
  computed: {
    formatBalance() {
      return (this.current_balance);
    },
    fromDateFormatted() {
      return this.mainFilters.from_date ? this.formatUtils.formatDateString(this.mainFilters.from_date) : '';
    },
    toDateFormatted() {
      return this.mainFilters.to_date ? this.formatUtils.formatDateString(this.mainFilters.to_date) : '';
    }
  },
  watch: {
    searchQuery() {
      this.filterSearch();
    },
    '$store.state.user.seller_info': {
      immediate: true,
      handler(newVal) {
        if (this.mainFilters.seller_id != null) {
          const businessName = "SELLER - " + newVal?.business_name || "SELLER";
          this.$store.commit("setPageTitle", {
            pageTitle: [
              { icon: "arrow-left", page: "BILLETERA " },
              { icon: "", page: businessName },
            ]
          });
        } else {
          this.$store.commit("setPageTitle", { pageTitle: [{ icon: '', page: "BILLETERA" }] });
        }
      }
    }
  },
  mounted() {
    this.mainFilters.seller_id = this.$route.params.id != undefined ? parseInt(this.$route.params.id) : null;
    this.loadBalance();
    this.loadList(this.service, this.getFilterParams());
  },
  created() {
    const { state } = this.$route.params;

    if (state) {
      this.depositStep = 2;
      this.setDepositStatus(state);
      this.dialog_wallet = true;
    }
  },
  methods: {
    async loadBalance() {
      const params = { seller_id: this.mainFilters.seller_id};
      await this.$store.dispatch('loadBalance', params); 
      this.current_balance = this.$store.state.user.balance;
      this.seller_info = this.$store.state.user.seller_info;
    },
    updateDialogWallet(value) {
      if (!value) {
        this.$router.push("/wallet");
      }
      this.dialog_wallet = value;
    },
    setDepositStatus(state) {
      switch (state) {
        case "success":
          this.depositPaymentStatus = "success";
          this.depositStatusTitle = "¡Listo! Tu depósito se acreditó";
          this.depositStatusMessage = "El dinero ya está disponible en tu billetera virtual";
          break;
        case "failure":
          this.depositPaymentStatus = "failure";
          this.depositStatusTitle = "Hubo un error al procesar tu depósito";
          this.depositStatusMessage = "Intenta el depósito nuevamente con otro medio de pago";
          break;
        case "pending":
          this.depositPaymentStatus = "pending";
          this.depositStatusTitle = "Tu depósito está pendiente de aprobación";
          this.depositStatusMessage = "Estamos procesando tu depósito </br> en unos minutos verás el resultado en tu billetera";
          break;
        default:
          this.depositPaymentStatus = "error";
          this.depositStatusTitle = "Estado desconocido";
          this.depositStatusMessage = "Hubo un problema al procesar tu depósito.";
      }
      
      if (state === "success") {
        this.loadBalance();
        this.loadList(this.service, this.getFilterParams);
      }
    },
    onDepositCreated() {
      this.loadBalance();
      this.loadList(this.service, this.getFilterParams());
    },
    handleAddMoney() {
      this.depositStep = 1;
      this.dialog_wallet = true;
    },
    getFilterParams() {
      const params = {};
      if (this.mainFilters.from_date) {
        params.from_date = this.formatUtils.formatDateString(this.mainFilters.from_date);
      }
      if (this.mainFilters.to_date) {
        params.to_date = this.formatUtils.formatDateString(this.mainFilters.to_date);
      }
      if (this.mainFilters.seller_id) {
        params.seller_id = this.mainFilters.seller_id;
      }

      return params;
    },
    filter() {
      const params = this.getFilterParams();
      this.loadBalance();
      this.loadList(this.service, params);
    },
    
    getMovementIcon(movement) {
      if (movement.order_info) {
        return 'mdi-file-document-outline';
      }
      return movement.debe > 0 && movement.haber == 0 ? 'mdi-arrow-up' : 'mdi-arrow-down';
    },
    
    getMovementColor(movement) {
      if (movement.debe > 0 && movement.haber === 0) {
        return 'success'; 
      } else if (movement.haber > 0 && movement.debe === 0) {
        return 'error'; 
      }
      return 'grey';
    },
    
    getMovementTitle(movement) {
      if (movement.order_info) {
        return `Pago de orden #${movement.order_info.order_quoting_id}`;
      }
      return movement.debe > 0 && movement.haber == 0 ? 'Ingreso de dinero' : 'Retiro de dinero';
    },
    
    getMovementDescription(movement) {
      if (movement.order_quoting && movement.order_quoting.seller_order && movement.order_quoting.seller_order.order_quoting != null) {
        return `Pago a ${movement.order_quoting.seller_order.order_quoting.contact_data.business_name}`;
      } 

      if(movement.mp_payment && movement.mp_payment.payment_id) {
        return `Operación ${movement.mp_payment.payment_id}`;
      }

     },
    getMovementAmountText(movement) {
      if (movement.debe > 0 && movement.haber === 0) {
        return `+${this.formatUtils.formatPrice(movement.debe)}`;
      } else if (movement.haber > 0 && movement.debe === 0) {
        return `-${this.formatUtils.formatPrice(movement.haber)}`;
      }
    },
  }
};
</script>
